const submitButtons = [].slice.call(document.querySelectorAll('[data-submit]'));

if (submitButtons !== null) {
  submitButtons.forEach((button) => {
    // set event listener
    button.addEventListener('click', () => {
      button.closest('form').submit();
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/submit.js